import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Button, Icon, Image } from '@pella/sash-framework';

const CTA = ({ data, renderAs, className, children, wide, ...other }) => {
	if (!data?.destination?.[0]?.destination && !other.onClick) return null;

	const linkCheckArray = ['http', 'www.', 'mailto:', '?', '#'];

	const renderContent = () => (
		<>
			{data.material_symbol && (
				<Icon
					className='mr-1.5'
					name={data.material_symbol}
					size={16}
				/>
			)}
			{data.file?.url && (
				<Image
					src={data.file.url}
					className='mr-1'
					{...data.file.gatsbyImageData?.images?.fallback}
				/>
			)}
			{children || data.cta_title || data.destination?.[0]?.default_heading}
		</>
	);

	const renderButton = () => (
		<Button
			href={data.destination?.[0]?.destination}
			color={data.button_style}
			target={data.target_blank ? '_blank' : '_self'}
			title={data.ada_title}
			rel={data.target_blank ? 'noopener noreferrer' : null}
			aria-label={data.aria}
			passTo={!linkCheckArray.some((item) => data.destination?.[0]?.destination?.includes(item)) && !data.target_blank ? true : false}
			component={!linkCheckArray.some((item) => data.destination?.[0]?.destination?.includes(item)) && !data.target_blank ? Link : null}
			className={`flex items-center justify-center ${data.button_style === 'primary' ? 'border-white text-white' : ''} ${className || ''}`}
			wide={wide}
			{...other}
		>
			{renderContent()}
		</Button>
	);

	const renderTextLink = () => {
		const LinkTag = data.target_blank || linkCheckArray.some((item) => data.destination?.[0]?.destination?.includes(item)) || other.onClick ? 'a' : Link;

		return (
			<LinkTag
				href={LinkTag === 'a' ? data.destination[0].destination : null}
				to={LinkTag !== 'a' ? data.destination[0].destination : null}
				target={data.target_blank ? '_blank' : '_self'}
				rel={data.target_blank ? 'noopener noreferrer' : null}
				title={data.ada_title}
				aria-label={data.aria}
				className={className || null}
				{...other}
			>
				{renderContent()}
			</LinkTag>
		);
	};

	return !data.button_style || renderAs === 'link' ? renderTextLink() : renderButton();
};

CTA.propTypes = {
	data: PropTypes.object,
	renderAs: PropTypes.string,
	className: PropTypes.string,
	children: PropTypes.node,
	wide: PropTypes.bool,
};

export default CTA;
